module.exports = __webpack_public_path__ + "static/img/post_3.eabe021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/posts/post_3.png
// module id = J3Om
// module chunks = 0